<template>
	<div class="camera-chooser">
		<Camera
			v-for="camera of CAMERAS"
			:key="camera.id"
			:name="camera.name"
			:icon-src="camera.icon"
			:active="camera.active"

			class="camera"

			@click="$emit('show-demo-notify')"
		/>
		<div class="frame"/>
	</div>
</template>

<script>

import Camera from '@/components/CameraChooser/camera';

const CAMERAS = [
	{
		id: 'go',
		icon: `<svg width="63" height="63" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
			<path fill-rule="evenodd" clip-rule="evenodd" d="M9.012 39.025h44.975c1.75 0 3.325-.875 4.288-2.275v6.212a7.245 7.245 0 0 1-7.262 7.263H12.075a7.245 7.245 0 0 1-7.262-7.263V36.75c.875 1.4 2.45 2.275 4.2 2.275Zm.963 4.638H53.025V41.3H9.975v2.363Z" fill="currentColor"/>
			<path d="M4.813 33.95c0 2.362 1.925 4.2 4.2 4.2h44.974c2.363 0 4.2-1.925 4.2-4.2V18.2c0-2.975-2.45-5.425-5.424-5.425H10.236c-2.974 0-5.425 2.45-5.425 5.425v15.75Zm37.274-13.3c0-2.712 2.1-4.9 4.638-4.9h5.512c2.538 0 4.638 2.188 4.638 4.9v4.55c0 2.713-2.1 4.9-4.638 4.9h-5.512c-2.538 0-4.638-2.188-4.638-4.9v-4.55Zm-12.862-7.087h4.725v1.487a10.86 10.86 0 0 0-2.363-.263c-.787 0-1.662.088-2.362.263v-1.488Zm2.275 2.1c4.638 0 8.487 3.762 8.487 8.487a8.44 8.44 0 0 1-8.487 8.488 8.44 8.44 0 0 1-8.488-8.488c0-4.725 3.85-8.487 8.488-8.487ZM6.125 20.65c0-2.712 2.1-4.9 4.637-4.9h5.513c2.538 0 4.638 2.188 4.638 4.9v4.55c0 2.713-2.1 4.9-4.638 4.9h-5.512c-2.538 0-4.638-2.188-4.638-4.9v-4.55Z" fill="currentColor"/>
			<path d="M6.737 25.113c0 2.45 1.925 4.462 4.288 4.462H16.1c2.362 0 4.2-2.012 4.287-4.462H6.737Z" fill="currentColor"/>
		</svg>
		`,
		name: 'Go',
		active: true,
	},
	{
		id: 'now',
		icon: `<svg width="60" height="60" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M10.613 11.13c-1.378.604-2.307 1.908-2.5 3.467-.096.731-.416 5.184-.673 9.922-.256 4.707-.576 9.764-.672 11.195l-.193 2.64H52.81l-.192-2.8c-.128-1.526-.449-7.091-.769-12.402-.64-10.654-.64-10.75-2.948-11.895-.993-.54-2.563-.572-19.192-.572-14.418.032-18.295.127-19.096.445Zm21.018.732c0 .477-.32.572-1.922.572-1.634.032-1.923-.063-1.923-.54 0-.478.289-.573 1.923-.573 1.602 0 1.922.095 1.922.54Zm-15.155.763c3.813 1.431 4.806 6.456 1.826 9.255-2.851 2.64-7.433 1.685-8.971-1.877-1.923-4.42 2.627-9.095 7.145-7.378Zm32.906.318c.769.604.833.827.833 3.117 0 3.085-.417 3.593-3.204 3.784-3.78.286-4.806-.509-4.806-3.625 0-3.34.577-3.88 4.197-3.912 1.698-.032 2.307.095 2.98.636Zm-15.444 1.145c2.916 1.558 4.742 4.548 4.742 7.728 0 4.77-4.165 8.905-8.971 8.905s-8.972-4.135-8.972-8.905c0-1.781.834-4.166 1.923-5.502 1.09-1.304 3.332-2.703 4.902-3.117 1.762-.445 4.646-.031 6.376.89Zm-17.75 11.226c1.41 1.304.416 3.817-1.442 3.817-.93 0-2.34-1.336-2.34-2.163 0-.35.29-.986.674-1.463.8-1.018 2.114-1.081 3.108-.19Zm-9.549 17.11c0 3.594.513 4.898 2.275 5.852 1.026.54 2.307.572 20.955.572 19.128 0 19.897-.031 20.89-.636 1.635-.986 2.02-2.067 2.02-5.724v-3.18H6.638v3.116Zm41.974 1.495v1.113l-18.808-.064-18.84-.095-.096-1.05-.096-1.017h37.84v1.113Z" fill="currentColor"/>
		</svg>
		`,
		name: 'Now',
		active: false,
	},
	{
		id: 'now-plus',
		icon: `<svg width="50" height="50" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M2.43 34.236v5.278c0 2.361 1.945 4.305 4.306 4.305h36.597c2.361 0 4.306-1.944 4.306-4.305v-5.278H2.43Zm41.112 5.556H6.528v-1.875h37.014v1.875Zm-20.348-13.89a8.62 8.62 0 0 0 1.875.21c.625 0 1.32-.07 1.875-.21v7.71H47.5l-1.32-23.056c0-2.362-1.944-4.306-4.305-4.306H8.125c-2.361 0-4.306 1.944-4.306 4.306L2.431 33.61h20.763v-7.708ZM42.5 24.029h-.972V25h-.764v-.972h-.972v-.764h.972v-.972h.764v.972h.972v.764Zm-5.347-13.611a2.49 2.49 0 0 1 2.5-2.5h2.986a2.49 2.49 0 0 1 2.5 2.5v2.291a2.49 2.49 0 0 1-2.5 2.5h-2.986a2.49 2.49 0 0 1-2.5-2.5v-2.291ZM10.069 23.958a2.164 2.164 0 0 1-2.152-2.152c0-1.181.972-2.153 2.152-2.153 1.181 0 2.153.972 2.153 2.153.07 1.18-.903 2.152-2.153 2.152Zm5.278-9.722c0 1.875-1.458 3.333-3.333 3.333H8.056c-1.875 0-3.334-1.458-3.334-3.333v-3.055c0-1.875 1.459-3.334 3.334-3.334h3.958c1.875 0 3.333 1.459 3.333 3.334v3.055Zm.972 2.361c0-4.791 3.89-8.68 8.681-8.68 4.792 0 8.68 3.889 8.68 8.68 0 4.792-3.888 8.68-8.68 8.68s-8.68-3.888-8.68-8.68Z" fill="currentColor"/>
		</svg>
		`,
		name: 'Now+',
		active: false,
	},
	{
		id: '600',
		icon: `<svg width="52" height="59" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M9.236 6.426c-.09.148-.24 2.695-.33 5.716-.18 4.738-.15 6.012.39 9.447.36 2.191.63 5.42.63 7.166 0 3.021-.03 3.228-.6 3.228s-.6.208-.6 5.686c.03 7.522.63 13.8 1.38 14.363.42.296 3.839.385 17.273.385h16.734l.3-.681c.39-.948.9-9.388.9-14.896 0-4.53-.03-4.798-.6-4.946-.54-.148-.6-.414-.6-3.435 0-1.777.27-5.064.6-7.314.6-3.91.63-9.477.12-13.682l-.15-1.244H27.02c-9.717 0-17.724.089-17.784.207Zm32.598 2.34c.63.622.69 4.916.06 5.42-.27.236-1.95.325-5.308.266l-4.918-.09-.09-2.664c-.06-2.251 0-2.725.42-3.021.39-.267 1.859-.385 4.948-.385 3.628 0 4.498.089 4.888.474ZM23.51 17.384c.09.148.18 1.57.24 3.198l.12 2.961H11.875l-.09-2.784c-.03-1.54-.03-2.96.06-3.198.12-.296 1.41-.385 5.848-.385 3.119 0 5.758.09 5.818.208Zm18.653 3.05v3.11H30.468l.12-2.962c.06-1.629.15-3.05.24-3.198.06-.119 2.64-.178 5.728-.149l5.608.09v3.109Zm-.33 4.916c.42.385.48 1.392.48 6.456 0 4.264-.09 6.07-.36 6.337-.51.504-6.867.504-7.377 0-.27-.267-.36-2.073-.36-6.337 0-7.286-.21-6.93 4.258-6.93 2.22 0 2.999.118 3.359.474Zm-10.886 1.007c.51.296.57.651.57 3.79 0 2.34-.12 3.613-.36 3.85-.51.504-18.863.504-19.373 0-.24-.237-.36-1.51-.36-3.85 0-2.99.06-3.494.54-3.76.69-.415 18.203-.445 18.983-.03Zm.21 10.72-.09.977h-7.497l-.09-.977-.09-.948h7.857l-.09.948Zm11.695 7.404c.6.592.48 5.537-.15 6.218-.45.504-1.319.534-15.294.534-9.656 0-15.024-.119-15.414-.297-.51-.296-.57-.651-.57-3.198 0-1.866.12-3.02.36-3.258.51-.503 30.559-.503 31.068 0Z" fill="currentColor"/>
			<path d="M34.967 26.416c-.09.385-.12 3.02-.09 5.863l.09 5.183h6.597l.09-5.183c.03-2.843 0-5.478-.09-5.863-.15-.622-.3-.652-3.299-.652s-3.148.03-3.298.652Zm-22.642 3.79v3.258l9.237-.06 9.206-.088v-6.219l-9.206-.089-9.237-.06v3.258ZM29.15 28.4c1.77 1.747.66 4.472-1.83 4.472-2.489 0-3.598-2.725-1.829-4.472 1.2-1.155 2.46-1.155 3.659 0ZM12.145 45.398c-.09.237-.12 1.392-.06 2.607l.09 2.191 15.055.089 15.084.06.15-.682c.09-.355.15-1.54.09-2.576l-.09-1.925-15.084-.09c-12.446-.059-15.085 0-15.235.326Zm29.569 3.465c0 .593-.21.593-14.394.593-14.185 0-14.395 0-14.395-.593 0-.592.21-.592 14.395-.592 14.184 0 14.394 0 14.394.592ZM5.428 39.98v2.665h2.399v-5.33h-2.4v2.665Z" fill="currentColor"/>
		</svg>
		`,
		name: '600',
		active: false,
	},
	{
		id: 'sx-700',
		icon: `<svg width="50" height="52" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M16.445 4.516c-1.097 1.097-1.13 1.161-1.13 3.903v2.773h-2.453c-1.323 0-2.744.161-3.099.355-.678.355-2.066 3.128-4.81 9.643-2.162 5.03-2.162 7.74-.064 7.74.613 0 .742-.162.742-.903 0-1.29.549-1.677 2.486-1.677 1.227 0 1.743.129 1.97.548.29.484.386.451 1.194-.161 1-.806 2.711-1.193 3.84-.903.453.096 1.26.58 1.809 1.032 1 .87 1 .87 1.194.161.162-.677.29-.677 6.747-.677 6.23 0 6.585.032 6.908.645.29.516.678.645 2.098.645 1.743 0 1.776 0 1.776-.968 0-.806.129-.967.775-.967.42 0 1.29.355 1.969.838l1.194.806.517-.709c.387-.58.71-.677 1.872-.516 1.775.194 2.389.677 2.389 1.903 0 .838.096.935.904.838.839-.096.871-.161.968-2.16.097-1.71-.065-2.516-.936-4.677-1.743-4.354-4.487-9.997-5.036-10.449-.323-.226-1.55-.387-3.034-.387h-2.486l-.13-2.902c-.096-2.645-.16-2.967-1-3.774l-.871-.903-7.619-.096-7.586-.097-1.098 1.096Zm8.394 9.579h8.199l.097-1.29c.129-1.903.742-1.58.742.387V14.9l-8.942.097-8.974.064v-1.71c0-2.16.452-2.74.581-.74l.097 1.483h8.2Zm-7.005 2.676.096.871 7.005-.064 7.005-.097.097-.903c.065-.516.29-.87.614-.87.387 0 .452.225.258 1.193-.13.677-.29 1.322-.355 1.45-.097.162-3.551.259-7.683.259h-7.522l-.226-1c-.29-1.516-.226-1.967.226-1.838.194.096.42.548.485 1Zm1.259 3.129c.16.613.451.645 5.94.645 5.552 0 5.778-.033 5.778-.645 0-.355.226-.645.484-.645.58 0 .613.29.161 1.419l-.323.838h-6.262c-6.682 0-6.65 0-6.65-1.645 0-.806.645-.806.872.033Z" fill="currentColor"/>
			<path d="M18.737 27.801c-.516.806-.613.806-4.713.806-3.873 0-4.196-.032-4.519-.677-.29-.516-.613-.645-1.71-.548l-1.357.096v10.966l6.812.096 6.843.065-.323-1.29c-.484-1.806-.064-3.386 1.195-4.805 3.325-3.677 9.2-1.42 9.2 3.515 0 .742-.162 1.612-.323 1.967-.323.613-.161.613 6.586.613 6.94 0 6.972 0 7.134-.742.096-.387.064-2.967-.065-5.708l-.258-4.999-1.162-.097c-.936-.064-1.26.065-1.711.71-.517.838-.581.838-4.713.838-4.165 0-4.23 0-4.584-.806l-.355-.806h-11.46l-.517.806Zm20.596 5.192c1.84 1.87.549 4.967-2.066 4.967-1.743 0-2.906-1.161-2.906-2.903 0-2.644 3.067-3.934 4.972-2.064Zm-25.728.516c.936.871.936 2.097.032 3.064-1.388 1.484-3.81.516-3.81-1.516 0-2 2.293-2.967 3.778-1.548Zm-9.071 6.902-1.162 1v3.29c0 1.805.16 3.579.322 3.934.323.58.904.612 21.08.612 15.72 0 20.854-.096 21.144-.387.258-.258.388-1.612.388-4.03v-3.613l-1.066-.87-1.065-.84-7.554.033c-7.07.065-7.586.097-8.458.742-1.969 1.387-4.648 1.354-6.456-.032-.71-.58-1.452-.645-8.393-.742l-7.618-.097-1.162 1Z" fill="currentColor"/>
		</svg>
		`,
		name: 'SX-700',
		active: false,
	},
];

export default {
	name: 'CameraChooser',
	components: { Camera },
	setup() {
		return {
			CAMERAS,
		};
	},
};
</script>

<style lang="sass" scoped>
.camera-chooser
	position: relative
	display: flex

	&:hover
		.camera
			color: #000000

.frame
	top: 0
	left: 0
	position: absolute
	box-sizing: border-box
	width: 114px
	height: 114px
	color: #000000

	border: 2px solid #ffffff
	border-radius: 8px

	pointer-events: none
	touch-action: none

	transition: left 0.2s

	@media (max-width: 650px)
		width: 70px
		height: 70px

// here must be a function!
.camera-chooser
	.camera
		&:hover
			color: #ffffff

		&:nth-child(2):hover ~ .frame
			left: 114px * 1

		&:nth-child(3):hover ~ .frame
			left: 114px * 2

		&:nth-child(4):hover ~ .frame
			left: 114px * 3

		&:nth-child(5):hover ~ .frame
			left: 114px * 4

		@media (max-width: 650px)
			&:nth-child(2):hover ~ .frame
				left: 70px * 1

			&:nth-child(3):hover ~ .frame
				left: 70px * 2

			&:nth-child(4):hover ~ .frame
				left: 70px * 3

			&:nth-child(5):hover ~ .frame
				left: 70px * 4

</style>
